import { UnitActivationDetailsPage } from '@apps-common/apps/portal/pages/units/pages/activations/pages/activation-details/Index'

export const UnitActivationDetails = () => <UnitActivationDetailsPage />
